import React from 'react';
import { bio, bioTagline, event } from '../data/masterclass';
export function Bio() {
  return <section aria-labelledby="bio-heading" className="border-y border-ink-line bg-ink" data-id="element-13" data-mp="3j82xx4a9fypb">
      <div className="mx-auto grid w-full max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:py-24" data-id="element-14" data-mp="12850uwxut96">
        <img src={event.portraitUrl} alt="Curtis and Spring Eatmon IV" className="mx-auto w-full max-w-sm object-cover lg:mx-0 lg:sticky lg:top-16 lg:self-start" data-id="element-15" data-mp="3t726kmv0zucb" />

        <div data-id="element-16" data-mp="30id6mr5phv25">
          <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-17" data-mp="30iwl1xw5e1bf">
            Your hosts
          </p>
          <h2 id="bio-heading" className="mt-3 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-18" data-mp="3eab2w1ebjwgw">
            Curtis &amp; Spring Eatmon IV
          </h2>

          <div className="mt-8 space-y-6" data-id="element-19" data-mp="2hr3t86stem5a">
            {bio.map(paragraph => <p key={paragraph} className="text-lg leading-relaxed text-white/70" data-id="element-20" data-mp="1c71jb6p2dgf7">
                {paragraph}
              </p>)}
          </div>

          <p className="mt-10 border-l-2 border-gold pl-6 font-display text-2xl font-semibold uppercase leading-snug text-gold sm:text-3xl" data-id="element-21" data-mp="1h4jwxae10jtj">
            {bioTagline}
          </p>
        </div>
      </div>
    </section>;
}